// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st4[data-v-6d811d32] {\n  fill: #1A7BEE;\n}\n.st8[data-v-6d811d32] {\n  fill: #23286b;\n}\n", ""]);
// Exports
module.exports = exports;
